import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { BrandModelService } from 'app/services/models/brand-model.service';
import { BrandService } from 'app/services/models/brand.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-brand-model-create',
  templateUrl: './brand-model-create.component.html',
  styleUrls: ['./brand-model-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BrandModelCreateComponent implements OnInit {
  brandModel: FormGroup;

  brands: any[];

  @Input() selectBrandModal: any;
  constructor(
    private _coreSidebarService: CoreSidebarService,
    private brandService: BrandService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private brandModalService: BrandModelService) { }

  async ngOnInit() {
    this.initializeForm();
    await this.getAllBrand();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Check if 'kind' input has changed and if it is not null or undefined
    if (changes['selectBrandModal'] && this.selectBrandModal) {
      // Ensure the form is initialized before calling reset
      if (this.brandModel) {
        this.brandModel.reset();
      }
      // Update the form with the new values from 'kind'
      this.brandModel.patchValue({
        brandId: this.selectBrandModal.brandId,
        brandModelName: this.selectBrandModal.modelName
      });
    }
  }

  async getAllBrand() {
    const data = await this.brandService.getAllBrand(0, 1000, '');
    console.log(data);
    this.brands = data.brands;
  }

  toggleSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }

  initializeForm() {
    this.brandModel = this.formBuilder.group({
      brandId: [null, [Validators.required]],
      brandModelName: [null, [Validators.required, Validators.min(1), Validators.max(100)]]
    });
  }

  async onSubmit() {
    if (this.brandModel.valid) {
      console.log(this.brandModel.value);
      if (this.selectBrandModal) {
        const data = await this.brandModalService.updateBrandModels(this.selectBrandModal.id, this.brandModel.value.brandModelName, this.brandModel.value.brandId);
        if (data.status) {
          this.brandModalService.sendEvent(true);
          this.toggleSidebar('create-brand-modal');
          this.brandModel.reset();
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.brandModalService.createBrandModels(this.brandModel.value.brandModelName, this.brandModel.value.brandId);
        if (data.status) {
          this.brandModalService.sendEvent(true);
          this.toggleSidebar('create-brand-modal');
          this.brandModel.reset();
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      }
    }
  }


}
